<template>
  <el-scrollbar id="app" :class="getLanguageClass">
    <Header @onApiClick="onApiClick"></Header>
    <div class="app-main">
      <router-view v-if="$route.meta.title == '首页'"></router-view>
      <router-view
        v-else
        v-wechat-title="
          translateTitle($route.meta.title)
        "
      ></router-view>
    </div>
    <div class="top-icon" @click="onTopClick" v-show="gotop">
      <img src="./assets/img/mask/top-icon.png" alt="" />
    </div>
    <!-- <ChatWedget ref="ChatWedget" /> -->
    <LiveChatWidget
      v-if="!hideCustomer"
      :visibility="hiddenCustomer"
      license="18394092"
      :group="groupId"
      :chatBetweenGroups="false"
      :sessionVariables="sessionVariables"
      v-on:new-event="handleNewEvent"
    />

    <Footer v-if="!hideFooter" @onApiClick="onApiClick"></Footer>
    <AhIPDetector />
  </el-scrollbar>
</template>
<script>
import Header from "@/components/common/header.vue";
import Footer from "@/components/common/footer.vue";
import { translateTitle } from "@/assets/js/i18n";
// import ChatWedget from "./pages/customer-service/ChatWedget.vue";
import { LiveChatWidget } from "@livechat/widget-vue/v2";
import { mapActions, mapGetters } from "vuex";
import { VUE_CHANNEL_ID, VUE_UNION_STATION } from "@/assets/js/stationSetting";
import { getLangPackage } from "@/assets/js/lang";
import seoMixin from "@/pages/seo/seoMixin.vue";
import seoMixinHx from "@/pages/seo/seoMixinHx.vue";
import AhIPDetector from "@/components/AhIPDetector.vue";

export default {
  name: "App",
  mixins: [seoMixin, seoMixinHx],
  components: {
    Header,
    Footer,
    LiveChatWidget,
    AhIPDetector,
  },
  data() {
    return {
      title: "数字货币银行",
      groupId: "20",
      hiddenCustomer: "",
      hideFooter: false,
      gotop: false,
      isMaskex: false,
      is8V: false,
      isS6: false,
      isB9: false,
      isUEEx: false,
      is5A: false,
      isBitda: false,
      is8Coin: false,
      isHx: false,
      isRouterAlive: true,
      hideCustomer: true,
      sessionVariables: {
        uid: "",
        email: "",
        google: "",
        mobile: "",
        page: "",
        kyc_level: "",
      },
      countryList: [
        {
          id: "English",
          value: "en",
          valueFull: "en_US",
          id: "1",
        },
        {
          name: "日本語",
          value: "ja",
          valueFull: "ja_JP",
          id: "4",
        },
        {
          name: "한국인",
          value: "ko",
          valueFull: "ko_KR",
          id: "6",
        },

        {
          name: "Français",
          value: "fr",
          valueFull: "fr_FR",
          id: "7",
        },
        {
          name: "Español",
          value: "es",
          valueFull: "es_ES",
          id: "8",
        },
        {
          name: "Pусский",
          value: "ru",
          valueFull: "ru_RU",
          id: "9",
        },
        {
          name: "Deutsch",
          value: "de",
          valueFull: "de_DE",
          id: "10",
        },
        {
          name: "Português",
          value: "pt",
          valueFull: "pt_BR",
          id: "11",
        },
        {
          name: "हिंदी",
          value: "hi",
          valueFull: "hi_IN",
          id: "12",
        },
        {
          name: "Tiếng Việt",
          value: "vi",
          valueFull: "vi_VN",
          id: "13",
        },
        {
          name: "Pilipino",
          value: "tl",
          valueFull: "tl_PH",
          id: "14",
        },
        {
          name: "ภาษาไทย",
          value: "th",
          valueFull: "th_TH",
          id: "15",
        },
        {
          name: "Türk",
          value: "tr",
          valueFull: "tr_TR",
          id: "16",
        },
        {
          name: "Italiano",
          value: "it",
          valueFull: "it_IT",
          id: "17",
        },
        {
          name: "bahasa Indonesia",
          value: "id",
          valueFull: "id_ID",
          id: "18",
        },
        {
          name: "عربي",
          value: "ar",
          valueFull: "ar_AR",
          id: "25",
        },
        {
          name: "中文简体",
          value: "zh_CN",
          valueFull: "zh_CN",
          id: "2",
        },
        {
          name: "中文繁體",
          value: "zh_HK",
          valueFull: "zh_HK",
          id: "3",
        },
      ],
    };
  },
  provide() {
    return {
      reload: this.reload,
    };
  },
  watch: {
    userInfo() {
      if (this.userInfo) {
        this.sessionVariables.uid = this.userInfo.accountInfo.account_id;
        this.sessionVariables.email = this.userInfo.authInfo.open_email
          ? "yes"
          : "no";
        this.sessionVariables.google =
          this.userInfo.authInfo.open_google == 1 ? "yes" : "no";
        this.sessionVariables.mobile =
          this.userInfo.authInfo.open_mobile == 1 ? "yes" : "no";
        let DOMAIL = document.location.pathname;
        if (DOMAIL.indexOf("/login") >= 0) {
          this.sessionVariables.page = "log";
        } else if (DOMAIL.indexOf("/register") >= 0) {
          this.sessionVariables.page = "reg";
        } else if (DOMAIL.indexOf("/quicklycoins") >= 0) {
          this.sessionVariables.page = "qui";
        } else if (DOMAIL.indexOf("/markets") >= 0) {
          this.sessionVariables.page = "mar";
        } else if (DOMAIL.indexOf("/contract-exchange") >= 0) {
          this.sessionVariables.page = "fut";
        } else if (DOMAIL.indexOf("/exchange") >= 0) {
          this.sessionVariables.page = "spo";
        } else if (DOMAIL.indexOf("/delivery") >= 0) {
          this.sessionVariables.page = "fcm";
        } else if (DOMAIL.indexOf("/finances") >= 0) {
          this.sessionVariables.page = "fim";
        } else if (DOMAIL.indexOf("/aboutUs") >= 0) {
          this.sessionVariables.page = "abo";
        } else if (DOMAIL.indexOf("/ucenter") >= 0) {
          this.sessionVariables.page = "uct";
        }
        this.sessionVariables.kyc_level =
          this.userInfo &&
          this.userInfo.kycInfo &&
          this.userInfo.kycInfo.kyc_level;
      }
    }
  },
  created() {
    // Dynamically update the canonical link with hreflang for language
    this.$nextTick(() => {
      let canonicalLink = document.querySelector('link[rel="canonical"][hreflang]');
      if (!canonicalLink) {
        canonicalLink = document.createElement('link');
        canonicalLink.setAttribute('rel', 'canonical');
        document.head.appendChild(canonicalLink);
      }
      canonicalLink.setAttribute('hreflang', this.language);
      canonicalLink.setAttribute('href', window.location.origin + window.location.pathname + window.location.search + window.location.hash);
    });
    this.setTheme();
    const DOMAIL = document.location.pathname;
    if (this.userInfo) {
      this.sessionVariables.uid = this.userInfo.accountInfo.account_id;
      this.sessionVariables.email = this.userInfo.authInfo.open_email
        ? "yes"
        : "no";
      this.sessionVariables.google =
        this.userInfo.authInfo.open_google == 1 ? "yes" : "no";
      this.sessionVariables.mobile =
        this.userInfo.authInfo.open_mobile == 1 ? "yes" : "no";
    }

    if (DOMAIL.indexOf("/login") >= 0) {
      this.sessionVariables.page = "log";
    } else if (DOMAIL.indexOf("/register") >= 0) {
      this.sessionVariables.page = "reg";
    } else if (DOMAIL.indexOf("/quicklycoins") >= 0) {
      this.sessionVariables.page = "qui";
    } else if (DOMAIL.indexOf("/markets") >= 0) {
      this.sessionVariables.page = "mar";
    } else if (DOMAIL.indexOf("/contract-exchange") >= 0) {
      this.sessionVariables.page = "fut";
    } else if (DOMAIL.indexOf("/exchange") >= 0) {
      this.sessionVariables.page = "spo";
    } else if (DOMAIL.indexOf("/delivery") >= 0) {
      this.sessionVariables.page = "fcm";
    } else if (DOMAIL.indexOf("/finances") >= 0) {
      this.sessionVariables.page = "fim";
    } else if (DOMAIL.indexOf("/aboutUs") >= 0) {
      this.sessionVariables.page = "abo";
    } else if (DOMAIL.indexOf("/ucenter") >= 0) {
      this.sessionVariables.page = "uct";
    }
    this.sessionVariables.kyc_level =
      this.userInfo && this.userInfo.kycInfo && this.userInfo.kycInfo.kyc_level;
    this.$router.afterEach(() => {
      this.isHasFooter();
    });
    // Market/Spot/Home 手动触发
    this.changeDescription(this.translateTitle(this.$route.meta.description))
    this.$router.beforeEach((to, from, next) => {
      this.changeDescription(this.translateTitle(to.meta.description))
      this.isHasFooter();  
      next();
    });
    this.isHasFooter();
    setInterval(() => {
      window.location.reload();
    }, 6 * 60 * 60 * 1000);

    this.countryList.forEach((ele) => {
      if (ele.value == this.language) {
        this.groupId = ele.id;
      }
    });
    this.chooseLanguage();
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll, true);
  },

  computed: {
    ...mapGetters({
      userInfo: "user/userInfo",
      v8show: "user/v8show",
      language: "user/language",
      darkMode: "user/darkMode",
    }),

    getLanguageClass() {
      let tempClass = "";
      tempClass = this.language;
      if (tempClass == "" || tempClass == null || tempClass == undefined) {
        if (this.is8V || this.isMaskex || this.is5A || this.isHx) {
          tempClass = "en";
        } else if (this.isS6 || this.isB9 || this.isBitda) {
          let jsSrc = (
            navigator.language || navigator.browserLanguage
          ).toLowerCase();
          if (jsSrc == "zh-hk" || jsSrc == "zh-tw") {
            tempClass = "zh_HK";
          } else if (jsSrc.indexOf("zh") >= 0) {
            // 假如浏览器语言是中文
            tempClass = "zh_CN";
          } else {
            // 假如浏览器语言是英文
            tempClass = "en";
          }
        } else {
          tempClass = "en";
        }
      }
      return tempClass;
    },
  },

  methods: {
    translateTitle,
    handleNewEvent(event) {
      // console.log("LiveChatWidget.onNewEvent", event);
    },
    ...mapActions({
      changeLanguage: "user/changeLanguage",
      changeCurrency: "user/changeCurrency",
      changeDarkMode: "user/changeDarkMode",
    }),
    tipsDownload() {
      this.$refs.header8v.onDownloadTipsDialog();
    },
    onApiClick() {
      this.$refs.ChatWedget.onChatClick();
    },
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      scrollTop > 30 ? (this.gotop = true) : (this.gotop = false);
    },
    onTopClick() {
      const that = this;
      let timer = setInterval(() => {
        let ispeed = Math.floor(-that.scrollTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          that.scrollTop + ispeed;
        if (that.scrollTop === 0) {
          clearInterval(timer);
        }
      }, 16);
    },
    setTheme() {
      this.isUEEx = true;
      this.title = "UEEx | Cryptocurrency Exchange";
      document.getElementsByTagName("body")[0].className = "vab-theme-UEEx";
    },

    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    },
    showMaskexCustomerService() {
      const index1 = location.pathname.indexOf("/landingpage/register");
      if (index1 == -1) {
        this.showMaskexCustomer = true;
      } else {
        this.showMaskexCustomer = false;
      }
    },
    isHasFooter() {
      const index = location.pathname.indexOf("/login");
      const index1 = location.pathname.indexOf("/register");
      const index2 = location.pathname.indexOf("/assets");
      const index3 = location.pathname.indexOf("/forgetPwd");
      const index4 = location.pathname.indexOf("/LoginSecurity");
      const index5 = location.pathname.indexOf("/landingpage/register");
      if (
        index != -1 ||
        index1 != -1 ||
        index3 != -1 ||
        index4 != -1 ||
        index5 != -1
      ) {
        this.hideFooter = true;
      } else {
        this.hideFooter = false;
      }
      if (index5 != -1) {
        this.hideCustomer = true;
        this.hiddenCustomer = "hidden";
      } else {
        this.hiddenCustomer = "";
        this.hideCustomer = false;
      }
    },

    chooseLanguage() {
      let lastIsLang = false;
      let lastpath = window.location.href.split("/");
      this.countryList.forEach((item) => {
        if (item.value == lastpath[lastpath.length - 1]) {
          lastIsLang = true;
        }
      });
      if (
        (VUE_UNION_STATION == "8V" || VUE_UNION_STATION == "UEEx") &&
        !lastIsLang
      ) {
        const langPackage = getLangPackage(["en"]);
        this.$i18n.setLocaleMessage("en", langPackage["en"]);
        this.changeLanguage("en");
        this.$i18n.locale = "en";
        return;
      }

      if (
        (VUE_UNION_STATION == "8V" || VUE_UNION_STATION == "UEEx") &&
        lastIsLang
      ) {
        const langPackage = getLangPackage([lastpath[lastpath.length - 1]]);
        this.$i18n.setLocaleMessage(
          lastpath[lastpath.length - 1],
          langPackage[lastpath[lastpath.length - 1]]
        );
        this.changeLanguage(lastpath[lastpath.length - 1]);
        this.$i18n.locale = lastpath[lastpath.length - 1];
        return;
      }
      if (!(this.$route.params && this.$route.params.lang)) return;
      const langPackage = getLangPackage([this.$route.params.lang]);
      this.$i18n.setLocaleMessage(
        this.$route.params.lang,
        langPackage[this.$route.params.lang]
      );
      this.changeLanguage(this.$route.params.lang);
      this.$i18n.locale = this.$route.params.lang;
    },
    // 不同路beforeRouteEnter由动态添加description
    changeDescription(newDescription) {
      console.log('description', newDescription)
      if (newDescription) {  
        let description = document.querySelector('meta[name="description"]');  
        if (description) {  
          description.setAttribute('content', this.translateTitle(newDescription));  
        } else {  
          description = document.createElement('meta');  
          description.name = 'description';  
          description.content = this.translateTitle(newDescription);  
          document.head.appendChild(description);  
        }  
      }  else {
        let description = document.querySelector('meta[name="description"]');  
        if (description) {  
          description.setAttribute('content', this.translateTitle('UEEx is the Best Crypto and Stock Exchange Platform that makes trading easier. Sign up to start trading Now!!!'));  
        } else {  
          description = document.createElement('meta');  
          description.name = 'description';  
          description.content = this.translateTitle('UEEx is the Best Crypto and Stock Exchange Platform that makes trading easier. Sign up to start trading Now!!!');  
          document.head.appendChild(description);  
        }  
      }
    }
  },
};
</script>

<style lang="scss">
#app {
  &.fr {
    .app-main .side-menu {
      width: 266px;
    }
  }
  &.es {
    .app-main .side-menu {
      width: 280px;
    }
  }
  &.ru {
    .app-main .side-menu {
      width: 280px;
    }
  }
  &.de {
    .app-main .side-menu {
      width: 260px;
    }
  }
  &.vi {
    .app-main .side-menu {
      width: 260px;
    }
  }
  &.it {
    .app-main .side-menu {
      width: 260px;
    }
  }
  &.pt {
    .app-main .side-menu {
      width: 270px;
    }
  }
  &.tl {
    .app-main .side-menu {
      width: 280px;
    }
  }
  &.ar {
    .app-main {
      .home-page {
        // direction: rtl;
      }
    }
  }
}
#app {
  display: flex;
  font-family: PingFang SC, robotoregular, Hiragino Sans GB, Heiti SC,
    Microsoft YaHei, WenQuanYi Micro Hei, Helvetica, Arial, monospace, serif !important;
  flex-direction: column;
  font-style: normal;
  // min-width: 1440px;
  height: 100%;
  min-width: 1180px;
  background: #ecedf1;
  &.ar {
    .el-scrollbar__wrap {
      margin-right: 0;
      margin-left: -15px;
    }
  }
  .el-scrollbar__wrap {
    height: 102%;
  }
  // .el-scrollbar__view {
  //   height: 100%;
  // }
  .app-main {
    flex: 1;
    min-height: calc(100% - 281px);
    .side-menu {
      padding: 0px 0;
      background: rgba(255, 255, 255, 1);
      // border-radius: 4px;
      overflow: hidden;
      width: 206px;
      box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.07);
      z-index: 999;
      height: auto;
      float: left;

      .nav {
        li {
          text-align: left;
          justify-content: left;
          padding-left: 30px;
          box-sizing: border-box;
          height: 40px; // jason要求改为40

          i {
            margin-right: 15px;
          }
        }
        li.active {
          color: #fff;
          background: linear-gradient(
            315deg,
            rgba(39, 198, 131, 1) 0%,
            rgba(39, 198, 131, 1) 100%
          );
        }
      }
    }
    .el-form-item {
      text-align: left !important;
    }
  }
  .top-icon {
    position: fixed;
    right: 40px;
    bottom: 14%;
    cursor: pointer;
    z-index: 99999;
  }
  .el-checkbox {
    &:hover {
      .el-checkbox__input {
        .el-checkbox__inner {
          border-color: #409eff;
        }
      }
    }
  }
}
</style>
